export default (set, get, data) => set(
  () => ({
    promo: {
      ...data
    }
  }),
  false,
  { type: 'promo/addPromoItem', data }
);
